import { Typography } from '@customink/pigment-react';
import { PWC } from '~/adapters/typescript/propsWithChildren';

export function FeedbackText({ children }: PWC) {
    return <Typography variant="bodyShort1">{children}</Typography>;
}
